import { render, staticRenderFns } from "./ButtonWrapper.vue?vue&type=template&id=fc5ece10&"
import script from "./ButtonWrapper.vue?vue&type=script&lang=js&"
export * from "./ButtonWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc5ece10')) {
      api.createRecord('fc5ece10', component.options)
    } else {
      api.reload('fc5ece10', component.options)
    }
    module.hot.accept("./ButtonWrapper.vue?vue&type=template&id=fc5ece10&", function () {
      api.rerender('fc5ece10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ContentHeader/ButtonWrapper.vue"
export default component.exports